import { RVRoutingPage } from "@regal-voice/ui";
import { AppPagePaths } from "App/routes/paths";
import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import type { RegalRouteObject } from "App/routes/types";

const CopilotEditorPage = lazyWithRetries(
    "Copilot Editor Page",
    () => import("Pages/copilot/Pages/CopilotEditorPage/CopilotEditorPage")
);

export const copilotRoute: RegalRouteObject = {
    path: AppPagePaths.copilot,
    element: <RVRoutingPage />,
    hasNestedRoutes: false,
    children: [
        {
            index: true,
            element: <CopilotEditorPage />,
        },
    ],
};
